<div class="padding flex column fix-height">
	<b class="margin-bottom-small flex between">
		{{ data.title }}
	</b>

	<div class="flex column gap-small">
		@for (id of ids; track $index; let i = $index) {
			<div class="flex center">
				<input type="number" class="flex-1" [(ngModel)]="ids[i]" />

				@if (ids.length > 1) {
					<div class="hover red flex-0 nowrap margin-left-small" (click)="removeId(i)">
						<mat-icon class="small">close</mat-icon>
					</div>
				}
			</div>
		}
		<span class="primary hover" (click)="addId()">+ add</span>
	</div>

	<div class="flex column end margin-top-small">
		<div class="flex center">
			<button class="stroked margin-right-small" (click)="onClose()">
				<mat-icon class="small margin-right-smallest">undo</mat-icon>
				Discard
			</button>
			<button (click)="apply()" cdkFocusInitial>
				<mat-icon class="small margin-right-smallest">check</mat-icon>
				Apply
			</button>
		</div>
	</div>
</div>
